<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Overwatch (SS7)</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <OverwatchSearch></OverwatchSearch>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <OverwatchResult></OverwatchResult>
    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import OverwatchSearch from "./Overwatch-Search";
  import OverwatchResult from "./Overwatch-Result";
  import overwatchService from "../../../../common/api-services/overwatch-service";
  import initService from '../../../../common/api-services/init-service';

  export default {
    name: "OverwatchDashboard",
    components: {
      RouteBreadCrumb,
      OverwatchResult,
      OverwatchSearch,
    },
    data() {
      return {
      }
    },
    mounted() {
      document.title = 'Troubleshooting - Overwatch';
      if (this.noAccess) {
        this.$router.push('/restricted')
      } else {
        this.getStandardTypeFunc();
        this.getTypeFunc();
      }
    },
    computed: {
      noAccess() {
          // Determine access based on menu link configuration
          let userRoles = initService.getUserRoles();
          let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

          if (!link) {
              return true;
          } else {
              userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
              return userRoles.length === 0;
          }
      }
    },
    methods: {
      getStandardTypeFunc() {
        overwatchService.getStandardType().then(res => {
          let data = [];
          data.push({standard_id: '0', standard_name: ''});
          res.map(item => {
            data.push(item)
          });
          this.$root.$emit('standardTypeEmit', data)
        })
      },

      getTypeFunc() {
        overwatchService.getType().then(res => {
          let cmdCode = res.cmdcodes;
          let opcodes = res.opcodes;
          let data = [];
          data.push({});
          for (let item in cmdCode) {
            let detailItem = {key: cmdCode[item].cmd_code, value: cmdCode[item].cmd_name};
            data.push(detailItem)
          }
          data.push({});
          for (let item in opcodes) {
            let detailOtherItem = {key: opcodes[item].opcode, value: opcodes[item].opcode_name};
            data.push(detailOtherItem)
          }
          this.$root.$emit('overWatchTypeOption', data)
        });
      },
    }
  }
</script>

<style scoped>

</style>
